/*
 * EB Pack Builder — configurador libre.
 * Cliente elige uno por categoría y crea su pack. -10% si total ≥ 4 productos seleccionados (lo aplica el Discount Function).
 */
(function () {
  if (customElements.get('eb-pack-builder')) return;

  class EBPackBuilder extends HTMLElement {
    connectedCallback() {
      this.minItems = parseInt(this.dataset.minItems || '4', 10);
      this.summaryEl = this.querySelector('[data-eb-pb-summary]');
      this.totalEl = this.querySelector('[data-eb-pb-total]');
      this.savingsEl = this.querySelector('[data-eb-pb-savings]');
      this.btn = this.querySelector('[data-eb-pb-add]');
      this.statusEl = this.querySelector('[data-eb-pb-status]');
      this.options = Array.from(this.querySelectorAll('[data-eb-pb-option]'));
      this.selectionByCategory = new Map();

      this.options.forEach((opt) => {
        opt.addEventListener('change', () => this.handleChange(opt));
        if (opt.checked) this.handleChange(opt);
      });

      if (this.btn) this.btn.addEventListener('click', () => this.submit());
      this.update();
    }

    handleChange(opt) {
      const cat = opt.dataset.category;
      if (!cat) return;
      // Single selection per category: if a radio in same cat changes, browser handles uncheck
      // For checkboxes (multi within cat) we'd track differently — using radios here.
      this.selectionByCategory.set(cat, {
        variantId: opt.value,
        priceCents: parseInt(opt.dataset.price || '0', 10),
        title: opt.dataset.title || '',
        category: cat,
      });
      this.update();
    }

    selections() {
      return Array.from(this.selectionByCategory.values());
    }

    update() {
      const sel = this.selections();
      const total = sel.reduce((s, x) => s + x.priceCents, 0);
      const eligible = sel.length >= this.minItems;
      const discount = eligible ? Math.round(total * 0.10) : 0;
      const finalTotal = total - discount;

      if (this.summaryEl) {
        if (sel.length === 0) {
          this.summaryEl.textContent = 'Aún no has elegido ningún producto.';
        } else {
          this.summaryEl.textContent = sel.map((s) => s.title).join(' · ');
        }
      }
      if (this.totalEl) this.totalEl.textContent = window.EBPack.formatMoney(finalTotal, 'EUR');
      if (this.savingsEl) {
        if (eligible && discount > 0) {
          this.savingsEl.textContent = `Ahorras ${window.EBPack.formatMoney(discount, 'EUR')} con tu pack`;
          this.savingsEl.removeAttribute('hidden');
        } else {
          this.savingsEl.textContent = `Añade ${this.minItems - sel.length} producto(s) más para obtener -10%`;
          if (sel.length === 0) this.savingsEl.setAttribute('hidden', '');
          else this.savingsEl.removeAttribute('hidden');
        }
      }
      if (this.btn) {
        this.btn.disabled = sel.length === 0;
        this.btn.textContent = sel.length >= this.minItems
          ? `Añadir mi pack · ${window.EBPack.formatMoney(finalTotal, 'EUR')}`
          : sel.length > 0
          ? `Añadir ${sel.length} producto(s) sin descuento`
          : 'Elige al menos un producto';
      }
    }

    async submit() {
      if (!window.EBPack) return;
      const sel = this.selections();
      if (sel.length === 0) return;

      this.btn.disabled = true;
      this.btn.textContent = 'Añadiendo...';

      let success = false;
      try {
        await window.EBPack.addPackToCart(
          sel.map((s) => ({ variantId: s.variantId, quantity: 1 })),
          { sourceLabel: 'pack-builder', openDrawer: true }
        );
        success = true;
        if (this.statusEl) {
          this.statusEl.textContent = `Pack añadido (${sel.length} productos). Te llevamos al carrito.`;
          this.statusEl.classList.remove('eb-pb__status--error');
          this.statusEl.classList.add('eb-pb__status--ok');
        }
        // En la página /pages/configura-tu-pack no existe el cart-drawer-component
        // (solo se renderiza en page templates con header). Si EBPack no pudo
        // abrir el drawer, navegamos al cart para no dejar al cliente colgado.
        const drawer = document.querySelector('cart-drawer-component, cart-drawer-component dialog[open]');
        if (!drawer || !drawer.querySelector || !drawer.querySelector('dialog[open]')) {
          // Le damos un breve momento para que el drawer abra si va a hacerlo,
          // si en 600ms sigue sin abrirse, redirigimos.
          setTimeout(() => {
            const stillClosed = !document.querySelector('cart-drawer-component dialog[open]');
            if (stillClosed) window.location.href = '/cart';
          }, 600);
        }
      } catch (e) {
        if (this.statusEl) {
          this.statusEl.textContent = `No pudimos añadir el pack: ${e.message}`;
          this.statusEl.classList.remove('eb-pb__status--ok');
          this.statusEl.classList.add('eb-pb__status--error');
        }
      } finally {
        // SIEMPRE restaurar el botón. Antes solo se restauraba en error → si el
        // success path no provocaba navegación, el botón quedaba "Añadiendo..."
        // y disabled para siempre.
        if (!success) {
          this.btn.disabled = false;
        }
        this.update();
      }
    }
  }

  customElements.define('eb-pack-builder', EBPackBuilder);
})();
